import React from "react";
import "./StoreMap.css";

const StoreMap = () => {
  return (
    <section>
      {/* Top Part of the Section */}
      <div className="text-center mb-4">
        <p className="text-2xl font-bold text-blue-500"> Stores</p>
        <h2 className="lg:text-5xl md:text-4xl max-sm:text-3xl font-semibold pt-5">
          Our Stores
        </h2>
        <p className="text-lg max-sm:text-sm pt-5 font-semibold">
          We have 2 different stores in Rampura, Hazipara and Uttara.
        </p>
      </div>

      {/* Card Part of the Section */}

      <div className="flex flex-col items-center sm:items-center md:flex-row justify-center gap-3">

        <div className="max-w-xs bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 hover:scale-110 transition duration-500 cursor-pointer object-cover">
          <a
            href="https://www.google.com/maps/place/Invent+Tailors+and+Fabrics+%2F+%E0%A6%87%E0%A6%A8%E0%A6%AD%E0%A7%87%E0%A6%A8%E0%A7%8D%E0%A6%9F+%E0%A6%9F%E0%A7%87%E0%A6%87%E0%A6%B2%E0%A6%BE%E0%A6%B0%E0%A7%8D%E0%A6%B8+%E0%A6%93+%E0%A6%AB%E0%A7%87%E0%A6%AC%E0%A7%8D%E0%A6%B0%E0%A6%BF%E0%A6%95%E0%A7%8D%E0%A6%B8/@23.7568858,90.4128772,17z/data=!3m1!4b1!4m6!3m5!1s0x3755b950aa153c43:0xb0b41c53f173232!8m2!3d23.7568809!4d90.4171044!16s%2Fg%2F11h_7k62ln"
            target="_blank"
            rel="noreferrer"
          >
            <img
              className="rounded-t-lg"
              src="https://i.ibb.co/KDfvbNv/invent.png"
              alt="Store Rampura"
            />
          </a>
          <div className="p-5">
            <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
               Branch: Rampura
            </h5>
            <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">
              Address: 62 East Hazipara, DIT Road, Rampura, Dhaka - 1219
            </p>
          </div>
        </div>

        <div className="max-w-xs bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 hover:scale-110 transition duration-500 cursor-pointer object-cover">
          <a
            href="https://www.google.com/maps/place/INVENT+MART/@23.8367399,90.3665256,17z/data=!3m1!4b1!4m6!3m5!1s0x3755c16b2f6e9b8b:0x5149cd82c9e633e!8m2!3d23.836735!4d90.3691005!16s%2Fg%2F11s046scvh?entry=ttu"
            target="_blank"
            rel="noreferrer"
          >
            <img
              className="rounded-t-lg"
              src="https://i.ibb.co/dpMdxQn/mart.png"
              alt="Store Uttara"
            />
          </a>
          <div className="p-5">
            <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
              Branch: Uttara
            </h5>
            <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">
              Uttara South
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StoreMap;
